<template>
  <OrderList :physioFlag="true" />
</template>
<script  lang="js">
import OrderList from "@/components/OrderList.vue";
export default {
  name: 'OrderListOne',
  components: { OrderList }
}
</script>